import { ApiService } from "./../../../services/api.service";
import { AppService } from "./../../../services/app.service";
import { AuthService } from "./../../../services/auth.service";
import { Component, OnInit, ViewChild, ElementRef } from "@angular/core";
import { MatMenuTrigger } from "@angular/material/menu";
import { MatDialog } from "@angular/material/dialog";
import { ModalUserConfigComponent } from "./../../../modal-user-config/modal-user-config.component";
import { timer } from "rxjs";

@Component({
  selector: "app-nav",
  templateUrl: "./nav.component.html",
  styleUrls: ["./nav.component.scss"],
})
export class NavComponent implements OnInit {
  @ViewChild("tempoEntregaTrigger") menuTempoEntrega: MatMenuTrigger;

  @ViewChild('backDropBottomSheet') backDropBottomSheet!: ElementRef;

  constructor(
    public authService: AuthService,
    public appService: AppService,
    private dialog: MatDialog
  ) { }

  ngOnInit(): void {
    this.appService.onToogleBottomSheetConfig$.subscribe((isVisible) => {

      if (!isVisible) {
        return timer(500).subscribe(() => {
          this.backDropBottomSheet.nativeElement.style.display = "none";
        });
      }

      this.backDropBottomSheet.nativeElement.style.display = "block";
    })
  }

  get nomeLoja() {
    return this.authService.usuario.NomeLoja;
  }

  trocarTema() {
    this.appService.tema = this.appService.tema === "dark" ? "light" : "dark";
    document.getElementsByTagName('HTML').item(0).setAttribute("class", this.appService.tema);
  }

  alterarTempoEntrega() {
    this.appService.alterarTempoEntrega();
    this.menuTempoEntrega.closeMenu();
  }

  abrirModalAlterarSenha() {
    this.appService.modalAlterarSenha = this.dialog.open(
      ModalUserConfigComponent
    );
  }

  get nomeUsuario() {
    return this.authService.usuario.Nome?.split(" ")[0] ?? "Usuário";
  }
}
